// extracted by mini-css-extract-plugin
module.exports = {"error_page":"error_error_page__3Q-N7"};